import { createContext } from 'react'

import type { UploadRequest, UploadState } from './model'

export const UploadContext = createContext<{
    state: UploadState | null
    start: (request: UploadRequest) => boolean
    cancel: () => void
    retry: () => void
    dismiss: () => void
} | null>(null)
